import { useCallback, useEffect } from 'react'

import useInterval from '@slergberg/react-hook-use-interval'

import { normalizeDeck } from './normalizers'
import { useApplicationApiRequest } from '../../hooks/useApplicationApi'

export default function useDeckReloadApi(deck, options) {
  const { disabled: deckDisabled, id: deckId, status: deckStatus } = deck
  const { authorizationToken, setDeck } = options

  const { execute, isError, isLoading, response } = useApplicationApiRequest(
    `/hackathon/hackpelofuturo/decks/${deckId}`,
    {
      autoExecute: false,
      headers: { Authorization: `Bearer ${authorizationToken}` },
      method: 'GET',
    },
  )

  const reloadDeck = useCallback(() => {
    if (!isLoading) {
      execute()
    }
  }, [execute, isLoading])

  const { stop: stopRefreshingDeck } = useInterval(reloadDeck, 1000, {
    autoStart: !deckDisabled,
  })

  useEffect(() => {
    if (!isLoading && !isError && response) {
      setDeck(normalizeDeck(response.data))

      if (['error', 'success'].indexOf(response.data.status) >= 0) {
        stopRefreshingDeck()
      }
    }
  }, [deckStatus, isError, isLoading, response, setDeck, stopRefreshingDeck])
}
